import { Comments } from "../../../../features/comments/components/comments/comments.component";
import { useSelector } from "react-redux";
import {
  selectWorkOrderId,
  selectWorkOrderResourceType,
} from "../../../../redux/selectors/workOrders";
import { HiddenHeading } from "../../../pages.styles";

export interface WorkOrderCommentsTabProps {
  pageTitle?: string;
}

export const WorkOrderCommentsTab = (props: WorkOrderCommentsTabProps) => {
  const modelId = useSelector(selectWorkOrderId);
  const modelName = useSelector(selectWorkOrderResourceType);

  return (
    <>
      <HiddenHeading>{props.pageTitle}</HiddenHeading>
      <Comments modelId={modelId} modelName={modelName} />
    </>
  );
};
